export const BASE = {
  name: 'playbacks',
  path: '/sites/:siteId/playbacks',
};

/**
 * @deprecated Use BASE path
 */
export const LIST = {
  name: 'playbacks.list',
  path: `${BASE.path}/list`,
};
